import React, { Component } from "react";
import { RefContainer, InputItem } from "../styles";

class InputRefHandlerRadius extends Component {
  inputBlurRadius = (e) => {
    const { currentValue, radiusOptions, name, updaterFn } = this.props;
    const radius = e.target.value;

    const { max } = radiusOptions;

    const value = Number(radius) >= max ? max : radius;

    updaterFn({
      prop: name,
      value: { ...currentValue, radius: value },
    });
  };

  inputChangeHandlerRadius = (e) => {
    const { currentValue, radiusOptions, name, updaterFn } = this.props;
    const radius = e.target.value;

    const { max } = radiusOptions;

    const value = Number(radius) >= max ? max : radius;

    updaterFn({
      prop: name,
      value: { ...currentValue, radius: value },
    });
  };

  render() {
    const { currentValue, radiusOptions } = this.props;
    const { radius } = currentValue;

    const { min, max, step } = radiusOptions;

    return (
      <RefContainer>
        <InputItem
          type="number"
          onChange={this.inputChangeHandlerRadius}
          onBlur={this.inputBlurRadius}
          min={min}
          max={max}
          step={step}
          value={radius}
        />
        <span>px</span>
      </RefContainer>
    );
  }
}

export default InputRefHandlerRadius;
